export default (
  state = {
    // bundles: [],
    categories: [],
    productFamilies: [],
    columnDefs: [],
    rowData: [],
    metaData: [],
    showPopUp: false,
  },
  action,
) => {
  switch (action.type) {
    case "REACTION_PRODUCTS_INIT_DATA":
      return {
        ...state,
        // bundles: action.payload[2].Bundles,
        categories: action.payload[2].Categories,
        columnDefs: action.payload[0].columnDefs,
        metaData: action.payload[0].metaData,
        productFamilies: action.payload[3].ProductFamilies,
        props: action.payload[0].props,
        rowData: action.payload[1].rowData,
      };
    case "UPDATE_ROW_DATA":
      return {
        ...state,
        rowData: action.payload,
      };
    case "TOGGLE_POP_UP":
      return {
        ...state,
        showPopUp: action.payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/ProductReducer.js